import {Component, Input, OnInit} from '@angular/core';
import {NgClass, NgIf} from "@angular/common";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {SvgIconComponent} from "../svg-icon/svg-icon.component";
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-input-password',
  standalone: true,
  imports: [
    NgIf,
    ReactiveFormsModule,
    NgClass,
    SvgIconComponent,
    TranslocoDirective
  ],
  templateUrl: './input-password.component.html',
  styleUrls: ['../input-text/input-text.component.scss', './input-password.component.scss']
})
export class InputPasswordComponent implements OnInit{
  @Input() label: string = "";
  @Input() hint: string = "";
  @Input({ required: true }) control!: FormControl;

  protected type: string = '';

  private readonly password: string = 'password'
  private readonly text: string = 'text'

  ngOnInit() {
    this.type = this.password
  }

  protected IsInValid():boolean {
    return this.control.invalid && this.control.touched;
  }

  protected togglePassword() {
    this.type = this.type === this.password ? this.text : this.password
  }
}
